document.addEventListener("DOMContentLoaded", function () {
  let buttons = document.querySelectorAll('input.option_input');
  for (let button of buttons) {
    button.addEventListener('click', uncheck);
  }
})

function uncheck() {
  setTimeout(() => {
    let button = document.querySelector('input.option_input:checked');
    if (button.checked == true) {
      button.checked = false;
    }
  }, 1000);
}